import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'manage-certificat-form',
    components: {
        VueEditor
    },
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_patient: {
            type: Object,
            default: () => ({})
        },
        info_user: Object,
        group_id: Number,
        form_toggler: Number,
        selected_content: {
            type: Object,
            default: () => ({})
        },
        data_to_be_deleted: {
            type: Object,
            default: () => ({})
        },
        slug: String,
        c_slug: String,
        liste_champs: Array,
        section_name: String,
        is_edit: {
            type: Number,
            default: () => (0)
        },
        del_toggler: {
            type: Number,
            default: () => (0)
        },
    },

    data() {
        return {
            customToolbar: vueEditorToolbar,
            save_loading: false,
            is_loading: false,
            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            section_data: {
                v_model: []
            },
            selected_champ: [],
            o_occurence: [],
            filtered_occurence: [],

            l_champs: []
        }
    },

    watch : {
        form_toggler() {
            if (this.is_edit == 0) {
                this.initFields()
            } else {
                this.setFormEdition()
            }
        },

        del_toggler() {
            this.openDelModal()
        }
    },

    computed: {
        
    },

    mounted() {

    },

    methods: {
        async setFormEdition() {
            this.l_champs = this.liste_champs
            
            this.section_data = {
                v_model: []
            }
            // this.is_loading = true

            await this.section_data.v_model.push(
                { 
                    value: this.selected_content.value, 
                    field_name: this.selected_content.field_name, 
                    type: this.selected_content.type 
                }
            );
            this.o_occurence.push('')
            this.selected_champ.push({selected_champ_occurences: []})
        },

        async initFields() {
            this.l_champs = []
            this.section_data = {
                v_model: []
            }
            this.is_loading = true
            let value  = ''
            let i = 0
            await this.liste_champs.forEach((c) => {
                if (c.is_active === 1) {
                    if (this.is_edit === 0) {
                        value = c.default_value

                        let content = value
                        content = content.replace("[NOM_MEDECIN]", this.info_user.nom_medecin)
                        content = content.replace("[NOM_PATIENT]", this.info_patient.nom_patient)
                        content = content.replace("[DATE_NAISSANCE_PATIENT]", this.info_patient.date_naissance)
                        content = content.replace("[VILLE]", this.ville_le)
                        content = content.replace("[DATE]", this.formatDateToDmY(this.current_date))
                        content = content.replace("[NOM_CLINIQUE]", this.nom_clinique)
                        content = content.replace("[AGE_CLINIQUE]", this.info_patient.age)

                        value = content

                        this.section_data.v_model.push(
                            { value: value, field_name: c.champ, type: c.type_champ }
                        );
                    } else {
                        this.section_data.v_model.push(
                            { 
                                value: this.selected_content.value, 
                                field_name: this.selected_content.field_name, 
                                type: this.selected_content.type 
                            }
                        );
                    }
                    
                    this.o_occurence.push('')
                    this.selected_champ.push({selected_champ_occurences: []})

                    this.l_champs.push(c)
                } 
                
                
                if (i == (this.liste_champs.length - 1)) {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 500);
                }
                i++
                
            });
        },

        saveData() {
            this.permission_is_denied = false
            this.is_error = false

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: JSON.stringify(this.info_user),
                data_type: this.slug,
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.section_data.v_model.forEach((champ, index) => {
                form_data.append(`champs[${index}]`, JSON.stringify(champ));
            });
            
            this.save_loading = true

            store_fiche.saveCustomSectionData(form_data).then((response) => {
                if (response.success) {
                    this.$refs.cert_section_form.click()
                    this.$emit('emitRefreshContent')
                    this.successToast(response.message)

                    this.section_data = {
                        v_model: []
                    },

                    this.selected_champ = []
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.cert_section_form.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        backToFields() {
            this.$refs.cert_section_form.click()

            this.$emit("emitOpenFields")
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerSection(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            store_fiche.deleteFicheSectionContent(this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit("emitRefreshContent")

                    this.$refs['del_certif'].hide()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        openDelModal() {
            this.is_error = false
            this.$refs['del_certif'].show()
        }
    }
}